<template>
    <table class="table border w-full">
        <thead>
            <tr>
                <sortable-header @sort="handleSort" sort-by="product_id" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2 whitespace-nowrap">Item #</sortable-header>
                <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2" sort-by="title">Item</sortable-header>
                <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="qty">Qty Sold</sortable-header>
                <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="qty_with_amts">
                    <div class="flex flex-col">
                        Qty <div class="text-xs">with $ amts</div>
                    </div>
                </sortable-header>
                <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="price_low">Low Price</sortable-header>
                <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="price_high">High Price</sortable-header>
                <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="price_avg_sum">Avg. Price</sortable-header>
                <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="profit">Profit</sortable-header>
                <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="margin">Margin</sortable-header>
                <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2" sort-by="price_total">Total</sortable-header>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item, index in data.items" :key="index">
                <td>{{ item.product_id }}</td>
                <td>{{ `${item.title} (${item.description})` }}</td>
                <td class="text-right">{{ item.qty }}</td>
                <td class="text-right">{{ item.qty_with_amts }}</td>
                <td class="text-right">{{ item.price_low ? `$${item.price_low}` : '--' }}</td>
                <td class="text-right">{{ item.price_high ? `$${item.price_high}` : '--' }}</td>
                <td class="text-right">{{ item.price_avg_sum ? `$${(item.price_avg_sum / item.price_avg_qty).toFixed(2)}` : '--' }}</td>
                <td class="text-right">{{ item.profit ? `$${item.profit.toFixed(2)}` : '--' }}</td>
                <td class="text-right">{{ item.margin ? `${(item.margin * 100).toFixed(1)}%` : '--' }}</td>
                <td class="text-right">{{ item.price_total ? `$${item.price_total.toFixed(2)}` : '--' }}</td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td colspan="2"></td>
                <td class="text-right">{{ data.total_qty }}</td>
                <td colspan="4"></td>
                <td class="text-right">${{ data.total_profit }}</td>
                <td class="text-right">{{ data.avg_margin }}%</td>
                <td class="text-right">${{ data.grand_total }}</td>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import SortableHeader from '@/Shared/SortableHeader';

export default {
    name: 'ItemSales',

    components: {
        SortableHeader,
    },

    props: ['data', 'sort_column', 'sort_direction'],
    emits: ['sort'],

    methods: {
        handleSort(sort) {
            this.$emit('sort', sort, 'items');
        },
    },
}
</script>